
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import item from './articulos-lista-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Articulo: Articulo;
        @Prop() public Items: Articulo[];
        @Prop() public Seleccionado: number;
        @Watch( 'Seleccionado' )
        onSeleccionado()
        {
            this.Seleccion = this.Seleccionado;
        }

        @Prop() public Busqueda: string;
        @Prop() public Estado: string;
        @Prop() public ExpandirDetalles: boolean;
        @Watch( 'ExpandirDetalles', { immediate: true } )
        onExpandirDetalles()
        {
            this.AbrirDetalles = this.ExpandirDetalles;
        }

        @Prop() public AgregarDirectamente: boolean;
        @Watch( 'AgregarDirectamente', { immediate: true } )
        onAgregarDirectamente()
        {
            this.AgregaDirectamente = this.AgregarDirectamente;
        }

        public Seleccion: number = -1;
        @Watch( 'Seleccion' )
        onSeleccion()
        {
            this.$emit( 'seleccion', this.Seleccion );
        }

        public VerImagenes: boolean = false;
        @Watch( 'VerImagenes' )
        onVerImagenes()
        {
            document.getElementById( 'barra-izquierda-input' ).focus();
        }
        public AbrirDetalles: boolean = false;
        public AgregaDirectamente: boolean = false;
        @Watch( 'AgregaDirectamente' )
        onAgregaDirectamente()
        {
            document.getElementById( 'barra-izquierda-input' ).focus();
            this.$emit( 'agregardirectamente', this.AgregaDirectamente );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.VerImagenes = this.Controlador.Configuracion.Opciones.BuscadorArticulos.MostrarImagenes;
            this.AbrirDetalles = this.Controlador.Configuracion.Opciones.BuscadorArticulos.ExpandirDetalles;
            this.AgregaDirectamente = this.Controlador.Configuracion.Opciones.BuscadorArticulos.AgregaDirectamente;


        }

    }
